import { DaDataAddress, DaDataSuggestion } from '@app/models/daData';

export type ParsedAddress = {
  country: string;
  postal_code: string;
  region: string;
  city: string;
  street_name: string;
  street_number: string;
  provider_address_uid: string;
  lat?: string;
  lon?: string;
  display: string;
  place_name: string;
};

export function mapDaDataSuggestionToParsed(data: DaDataAddress, label?: string): ParsedAddress {
  return {
    country: data.country ?? '',
    postal_code: data.postal_code ?? '',
    region: data.region_with_type ?? '',
    city: data.city_with_type ?? data.settlement_with_type ?? '',
    street_name: data.street_with_type ?? '',
    street_number: data.house ?? '',
    provider_address_uid: data.house_fias_id || data.fias_id || '',
    place_name: data?.flat ?? '',
    lat: data?.geo_lat?.toString(),
    lon: data?.geo_lon?.toString(),
    display: label || '',
  };
}
